import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom'; 
import { useDispatch, useSelector } from 'react-redux';
import { verifyAccessToken } from './redux/slices/protectSlice';
import loaderImg from './images/loader.gif';

const ProtectedRoute = ({ allowedUserType, children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated, userType, isLoading } = useSelector((state) => state.protect);
  useEffect(() => {
    if (isAuthenticated == null || isAuthenticated == 'null') {
      dispatch(verifyAccessToken());
    }
  }, [isAuthenticated]);

  if (isLoading) {
    return <div style={overlayStyle}>
      <img src={loaderImg} alt="Loading..." style={loaderImageStyle} />
    </div>;
  }

  if (!localStorage.getItem('directlogin') && localStorage.getItem('directlogin') != '1') { 
    if (isAuthenticated === false || userType !== allowedUserType) {
       return <Navigate to="/login" replace />;
    }
  }
  
  if (isAuthenticated == 'null' || isAuthenticated == null) { return false; } 

  localStorage.removeItem('directlogin');
    return children;
  };

const overlayStyle = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 100000,
};

const loaderImageStyle = {
  width: '360px',
  height: '250px',
};

export default ProtectedRoute;